// removed by extract-text-webpack-plugin
module.exports = {"vpSidebarTitle":"vpSidebarTitle___2xYYM","vpDrawerLink":"vpDrawerLink___vDc0N","vpActiveLink":"vpActiveLink___IDphd","vpVideoCount":"vpVideoCount___1ehlN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/SidebarMenu.module.less
// module id = 3444
// module chunks = 29